import React from 'react'
import Style from './users.module.css'

const RolePermissionsDialog = ({ catalog, isError, onClose }) => (
    <div className={Style.dialogOverlay} role="dialog" aria-modal="true" aria-labelledby="role-permissions-title">
        <div className={`${Style.dialog} ${Style.dialogWide}`}>
            <div className={Style.dialogHeader}>
                <h3 id="role-permissions-title" className={Style.dialogTitle}>Role permissions</h3>
                <p className={Style.dialogSubtitle}>
                    What each role can do. A user with several roles gets the combined permissions of all of them.
                </p>
            </div>
            <div className={Style.dialogBody}>
                {isError ? <p>Could not load the role permissions. Try again later.</p> : null}
                {catalog ? (
                    <>
                        <div className={Style.tableScroll}>
                            <table className={Style.table}>
                                <thead>
                                    <tr>
                                        <th scope="col">Permission</th>
                                        {catalog.roles.map((role) => <th scope="col" key={role.value} className={Style.centerCell}>{role.label}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {catalog.permissions.map((permission) => (
                                        <tr key={permission.value}>
                                            <td>{permission.label}</td>
                                            {catalog.roles.map((role) => (
                                                <td key={role.value} className={Style.centerCell}>
                                                    {role.permissions.includes(permission.value) ? (
                                                        <>
                                                            <i className={`uil-check ${Style.allowed}`} aria-hidden="true" />
                                                            <span className="sr-only">Allowed</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span aria-hidden="true">&mdash;</span>
                                                            <span className="sr-only">Not allowed</span>
                                                        </>
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <ul className={Style.roleList}>
                            {catalog.roles.map((role) => (
                                <li key={role.value}><strong>{role.label}:</strong> {role.description}</li>
                            ))}
                        </ul>
                    </>
                ) : null}
            </div>
            <div className={Style.dialogFooter}>
                <button type="button" className={Style.ghostButton} onClick={onClose}>Close</button>
            </div>
        </div>
    </div>
)

export default RolePermissionsDialog
